import { render, staticRenderFns } from "./doctor.vue?vue&type=template&id=ce1a8fee&scoped=true"
import script from "./doctor.vue?vue&type=script&lang=js"
export * from "./doctor.vue?vue&type=script&lang=js"
import style0 from "./doctor.vue?vue&type=style&index=0&id=ce1a8fee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1a8fee",
  null
  
)

export default component.exports